import { Link, useParams } from "react-router-dom";
import { NewPill } from "../../../../Components/Utils/StatusPills";

import { TextSM } from "../../../../Components/Text/NormalText";
import NuDate from "../../../../Components/Utils/NuDate";
import ViewMore from "./ViewMore";

function Card({ item,getData }) {
    const { officeId } = useParams();
    return (
      <div className=" w-full border  bg-white rounded-lg shadow-xl mt-1.5 mb-2">
        <div className="flex justify-between bg-[#ECEBF3]  rounded-t-lg items-center px-4 py-2">
          <p className=" w-8 h-5 bg-slate-300  flex justify-center font-medium text-mainColor-500 items-center text-[12px] rounded-lg">
            {item?.stockId || "#"}
          </p>
          <div className=" flex items-center gap-3">
            <div className="flex items-center gap-2 overflow-hidden">
              {item?.status &&
               
                  <NewPill text={item?.status} />
              
                }
            </div>
            <ViewMore id={item?.stockId}         getData={getData}
 getProject={() => {}} data={item} />
          </div>
        </div>
        <div className=" px-2 pb-2">
          <div className=" px-2 w-full h-8 mt-2 truncate  overflow-hidden">
            <Link
              className="hover:text-blue-600 text-mainColor-400 font-semibold text-[12px] lg:text-[12px] xl:text-[12px] w-full flex justify-between items-center"
              to={`/main/${officeId}/store/assets/view/${item?.stockId}`}
              state={{ data: item }}
            >
              {item?.ref || "-"}
            </Link>
          </div>
          <div
            className="w-full flex justify-between items-center flex-wrap gap-2 mb-2 rounded-md p-2"
            style={{ border: "1px solid #C0C0C0" }}
          >
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"GRN No. : " || "-"} />
                <div className=" text-xs ">{item?.grnRef || "-"}</div>
              </div>
            </div>
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Product : " || "-"} />
                <div className=" text-xs ">{item?.productName || "-"}</div>
              </div>
            </div>
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Unit : " || "-"} />
                <div className=" text-xs ">{item?.unit || "-"}</div>
              </div>
            </div>
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Category : " || "-"} />
                <div className=" text-xs ">{item?.category || "-"}</div>
              </div>
            </div>
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Stock Qty : " || "-"} />
                <div className=" text-xs ">{item?.stockQty || "-"}</div>
              </div>
            </div>
  
           
          </div>
        </div>
      </div>
    );
  }
  
export default Card